import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ImageStyleToggleButtonGroup from './image-style-toggle-button-group';

const DefaultProperties = {
    xOffset: 0,
    yOffset: -200,
    maxWidth: 512,
    maxHeight: 512,
    style: 64 | 16,
    shadow: {
        radius: 12,
        opacity: 0.8,
    }
};

export default function ImageMetadataElement(props) {
    const properties = { ...DefaultProperties, ...props };

    const [xOffset, setXOffset] = useState(properties.xOffset);
    const [yOffset, setYOffset] = useState(properties.yOffset);
    const [maxWidth, setMaxWidth] = useState(properties.maxWidth);
    const [maxHeight, setMaxHeight] = useState(properties.maxHeight);
    const [style, setStyle] = useState(properties.style);
    const [useShadow, setUseShadow] = useState(properties.shadow !== null);
    const [shadowRadius, setShadowRadius] = useState(properties.shadow?.radius);
    const [shadowOpacity, setShadowOpacity] = useState(properties.shadow?.opacity);

    const { onUpdate } = properties;

    useEffect(() => {
        onUpdate({
            xOffset: xOffset,
            yOffset: yOffset,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            style: style,
            shadow: useShadow ? {
                radius: shadowRadius,
                opacity: shadowOpacity,
            } : null
        });
        // eslint-disable-next-line
    }, [xOffset, yOffset, maxWidth, maxHeight, style, useShadow, shadowRadius, shadowOpacity])

    return (
        <Grid container spacing={4} columns={{ xs: 2, sm: 6, md: 6, xl: 12 }}>
            <Grid size={2}>
                <TextField value={xOffset} label={'X-Offset'} type="number" required fullWidth onChange={event => setXOffset(event.target.value)} />
            </Grid>
            <Grid size={2}>
                <TextField value={yOffset} label={'Y-Offset'} type="number" required fullWidth onChange={event => setYOffset(event.target.value)} />
            </Grid>
            <Grid size={2}>
                <TextField value={maxWidth} label={'Max Width'} type="number" required fullWidth onChange={event => setMaxWidth(event.target.value)} />
            </Grid>
            <Grid size={2}>
                <TextField value={maxHeight} label={'Max Height'} type="number" required fullWidth onChange={event => setMaxHeight(event.target.value)} />
            </Grid>
            <Grid size={4}>
                <ImageStyleToggleButtonGroup style={style} onImageStyleUpdate={setStyle} />
            </Grid>

            <Grid size={2}>
                <FormGroup>
                    <FormControlLabel required control={<Checkbox checked={useShadow} onChange={event => setUseShadow(event.target.checked)} />} label="Use Shadow" />
                </FormGroup>
            </Grid>

            <Grid size={2}>
                {useShadow ? <TextField value={shadowRadius} label={'Shadow Radius'} type="number" required fullWidth onChange={event => setShadowRadius(event.target.value)} /> : null}
            </Grid>
            <Grid size={2}>
                {useShadow ? <TextField value={shadowOpacity} label={'Shadow Opacity'} type="number" required fullWidth onChange={event => setShadowOpacity(event.target.value)} /> : null}
            </Grid>
        </Grid>
    );
}

ImageMetadataElement.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    xOffset: PropTypes.number,
    yOffset: PropTypes.number,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    style: PropTypes.number,
    shadow: PropTypes.object,
};
